import { render, staticRenderFns } from "./ButtonPresetInput.vue?vue&type=template&id=442983c4&scoped=true&"
import script from "./ButtonPresetInput.vue?vue&type=script&lang=ts&"
export * from "./ButtonPresetInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442983c4",
  null
  
)

export default component.exports